import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement(Svg //   xmlns="http://www.w3.org/2000/svg"
  , _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm2-.5h16a.5.5 0 01.5.5v.432L12 12.099 3.5 6.432V6a.5.5 0 01.5-.5zm-.5 2.735V18a.5.5 0 00.5.5h16a.5.5 0 00.5-.5V8.235l-8.084 5.389a.75.75 0 01-.832 0L3.5 8.234z",
    fill: "#000",
    fillOpacity: 0.65
  }));
}
export default SvgComponent;